export const OTP_CODE_FULL_LENGTH = 6;
